/**
 * 시스템(권한·사용자·기관) 화면 공통 크롬 — hex 직접 기입 금지
 */
import styled from 'styled-components';
import { Card } from 'styles/common.styles';
import { theme, cssVar } from 'styles/theme';

export const Meta = styled.div`
  margin-bottom: 4px;
  flex-shrink: 0;
  color: ${cssVar('color-text-secondary', theme.colors.text.secondary)};
  font-size: ${theme.typography.fontSize.sm};
`;

export const Guide = styled(Card)`
  flex-shrink: 0;
  padding: 7px 12px;
  color: ${theme.colors.text.secondary};
  font-size: 0.77rem;
  line-height: 1.5;
`;

export const ModeTabBar = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 0;
  border-bottom: 1px solid ${cssVar('color-border', theme.colors.border)};
  padding: 0 8px;
`;

export const ModeTab = styled.button`
  appearance: none;
  background: ${(p) =>
    p.$active ? cssVar('color-bg-white', theme.colors.white) : 'transparent'};
  border: none;
  border-bottom: 2px solid
    ${(p) => (p.$active ? cssVar('color-primary', theme.colors.primary) : 'transparent')};
  color: ${(p) =>
    p.$active
      ? cssVar('color-primary-dark', theme.colors.primaryDark)
      : cssVar('color-text-secondary', theme.colors.text.secondary)};
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: ${(p) => (p.$active ? 600 : 500)};
  margin-bottom: -1px;
  padding: 8px 14px;
`;
